/* eslint-disable no-undef */
export default {
	name: "add-edit-customer",
	props:{
		companyId:{
			default: null
		}
	},
	data() {
		return {
			discountGroups: [],
			//salesReps: [],
			productTypes: [],
            paymentTypes: [],
			saleReps: [],
			customerProductTypes: [],
			companySalesReps: [],
			unselectedSalesReps: [],
			companyZonesLinkedAndUnlinkedToCompany: [],
			linkZonesErrorMessage: null,
			linkedZoneIds: [],
			unlinkedZoneIds: [],
			salesRepsHeadings: [
				{
					text: "Sales Rep",
					field: "salesRep"
				},
				{
					text: "Email Address",
					field: "salesRepEmail"
				}
			],
			initialiseDueDate: true,
			customer:{
				primaryUserId: null,
				customerCode: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				firstName: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				lastName: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				emailAddress: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				password: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				dateOfBirth: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				customerCanPlaceOrdersErrorMessage: null,
				customerCanPlaceCollectionOrders: false,
				customerCanPlaceDeliveryOrders: false,
				customerCanPlaceExTankOrders: false,
                paymentTypeId:{
                    value: null,
                    hasError: false,
                    errorMessage: null
                },
                creditLimit: {
                    value: 0,
                    hasError: false,
                    errorMessage: null
                },
				companyDetails: {
					businessName: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					tradingName: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					holdingCompany: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					registrationNumber: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					branch: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					branchNumber: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					telephoneNumber: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					discountGroupId: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					erpCustomerCode: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					salesRepId: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					salesRepName: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					vatNumber: {
						value: null,
						hasError: false,
						errorMessage: null
					}
				},
				isActive: true,
				productTypeIdsToLink: {
					value: [],
					hasError: false,
					errorMessage: null
				},
				productTypeIdsToUnlink: {
					value: [],
					hasError: false,
					errorMessage: null
				},
				salesRepsToLinkMessage:{
					value: null,
					hasError: false,
					errorMessage: null
				}
			},
			regeneratePassword: false,
			customerSalesRep:{
				heading: "Assign Sales Reps To Customer",
				modalId: "assignSalesRepToCustomerModal",
				showModal: false
			},
			isUpdate: false,
			resetPassword: false,
			errorModal:{
				modalHeading: "Error",
				elementId: "customerModalError",
				modalMessage: "",
				showModal: false
			},
			successModal:{
				modalHeading: "Success",
				elementId: "customerModalSuccess",
				modalMessage: "",
				showModal: false
			},
			loading: false,
			loadingFromApi: false,
            precision: 2,
            paymentType: paymentTypeHelper.paymentType,
            currentBalance: 0,
            amountOfCreditUsed: 0
		};
	},
	methods: {
		getCustomer(){
			this.loadingFromApi = true;
			let request = {
				companyId: this.companyId
			};
			customerService.getCompany(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						this.customer.customerCode.value = successResponse.data.result.customerCode;
						if(successResponse.data.primaryCustomerUser !== null && successResponse.data.primaryCustomerUser !== undefined){
							this.customer.primaryUserId = successResponse.data.primaryCustomerUser.userId;
							this.customer.firstName.value = successResponse.data.primaryCustomerUser.firstName;
							this.customer.lastName.value = successResponse.data.primaryCustomerUser.lastName;
							this.customer.emailAddress.value = successResponse.data.primaryCustomerUser.email;
							this.customer.dateOfBirth.value = "";
						}
						
						this.customer.companyDetails.businessName.value = successResponse.data.result.registeredCompanyName;
						this.customer.companyDetails.tradingName.value = successResponse.data.result.tradingAs;
						this.customer.companyDetails.holdingCompany.value = successResponse.data.result.holdingCompany;
						this.customer.companyDetails.registrationNumber.value = successResponse.data.result.companyRegistrationNumber;
						this.customer.companyDetails.branch.value = successResponse.data.result.branchName;
						this.customer.companyDetails.branchNumber.value = successResponse.data.result.branchNumber;
						this.customer.companyDetails.telephoneNumber.value = successResponse.data.result.primaryTelephoneNumber;
						this.customer.companyDetails.discountGroupId.value = successResponse.data.result.discountGroupId;
						this.customer.companyDetails.erpCustomerCode.value = successResponse.data.result.erpCompanyCode;
						this.customer.companyDetails.vatNumber.value = successResponse.data.result.taxVatNumber;
						this.customer.customerCanPlaceCollectionOrders = successResponse.data.result.enableCollectionOrders;
						this.customer.customerCanPlaceDeliveryOrders = successResponse.data.result.enableDeliveryOrders;
						this.customer.customerCanPlaceExTankOrders = successResponse.data.result.enableExTankOrders;
						this.customer.isActive = successResponse.data.result.isActive;
                        //this.customer.paymentTypeId.value = successResponse.data.result.paymentTypeId;
						var self = this;
						setTimeout(()=>{
							self.customer.paymentTypeId.value = successResponse.data.result.paymentTypeId;
							console.log("customer.paymentTypeId.value", self.customer.paymentTypeId.value);
						}, 800);
                        this.customer.creditLimit.value = successResponse.data.result.creditLimit;
						console.log("customer.creditLimit.value", this.customer.creditLimit.value);
						this.getCurrentBalance();
						this.setBreadcrumbs();
					}
					this.loadingFromApi = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loadingFromApi = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
        getCurrentBalance(){
            customerCreditsService.getCurrentCompanyCreditByCompany(this.companyId).then(
                successResponse => {
                    let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
                    if(isSuccess){
                        //success
                        console.log("success", successResponse);
                        // if(successResponse.data.result === null){
                        //     this.currentBalance = currencyHelper.numberToCurrency(0);
                        // }
                        // else{
                        //     this.currentBalance = currencyHelper.numberToCurrency(successResponse.data.result.currentBalance);
                        // }
                        if(successResponse.data.result !== null) {
                            this.currentBalance = successResponse.data.result.currentBalance === null ? 0 : successResponse.data.result.currentBalance;
                            this.calculateAmountOfCreditUsed();
                        }
                    }
                },
                errorResponse => {
                    //error
                    console.log("error", errorResponse);
                    apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
                }
            );
        },
        getPaymentTypes(){
            this.loadingFromApi = true;
            systemService.getPaymentTypes().then(
                successResponse => {
                    console.log("successResponse", successResponse);
                    let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
                    if(isSuccess){
                        this.paymentTypes = successResponse.data.result;
                        this.paymentTypes = $.map(this.paymentTypes,
                            function (obj) {
                                obj.id = obj.id || obj.paymentTypeId;
                                obj.text = obj.text || obj.name;
                                return obj;
                            });
						if (this.companyId !== null && this.companyId > 0) {
							this.isUpdate = true;
							this.getCustomer();
							//this.getCompanySalesReps();
						}
						else{
							this.setBreadcrumbs();
							this.isUpdate = false;
							this.generateCustomerCode();
						}
						this.getSalesRepsAssignedToCompany();
						this.getZonesLinkedAndUnlinkedToCompany();
                    }
                    this.loadingFromApi = false;
                },
                errorResponse => {
                    console.log("errorResponse", errorResponse);
                    apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
                }
            );
        },
		getSalesRepsAssignedToCompany(){
			console.log("companyId", this.companyId);
			let companyId = this.companyId;
			if(this.companyId === null || this.companyId === undefined || this.companyId === ""){
				companyId = 0;
			}
			let request = {
				companyId: companyId,
				searchQuery: this.searchQuery
			};
			securityService.getCompanySalesReps(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						// this.customer.companyDetails.salesRepId.value = successResponse.data.result.userId;
						// this.customer.companyDetails.salesRepName.value = successResponse.data.result.salesRep;
						this.saleReps = successResponse.data.result;
						for(var i = 0; i < this.saleReps.length; i++){
							if(this.saleReps[i].isAssigned){
								this.companySalesReps.push(this.saleReps[i]);
							}
							else{
								this.unselectedSalesReps.push(this.saleReps[i]);
							}
						}
					}
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getZonesLinkedAndUnlinkedToCompany(){
			this.loading = true;
			let companyId = this.companyId;
			if(this.companyId === null || this.companyId === undefined || this.companyId === ""){
				companyId = 0;
			}
			customerService.getZonesLinkedAndUnlinkedToCompany(companyId).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.companyZonesLinkedAndUnlinkedToCompany = successResponse.data.result;
						this.linkedZoneIds = this.companyZonesLinkedAndUnlinkedToCompany.filter(zone => zone.isSelected).map(zone => zone.zoneId);
						this.unlinkedZoneIds = this.companyZonesLinkedAndUnlinkedToCompany.filter(zone => !zone.isSelected).map(zone => zone.zoneId);
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		// getSalesRepsAssignedToCompany(){
		// 	let request = {
		// 		companyId: this.companyId === null ? 0 : this.companyId
		// 	};
		// 	securityService.getSalesRepsAssignedToCompany(request).then(
		// 		successResponse => {
		// 			console.log("successResponse", successResponse);
		// 			let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
		// 			if(isSuccess){
		// 				//success
		// 				// this.customer.companyDetails.salesRepId.value = successResponse.data.result.userId;
		// 				// this.customer.companyDetails.salesRepName.value = successResponse.data.result.salesRep;
		// 				this.companySalesReps = successResponse.data.result;
		// 				console.log("companySalesReps", this.companySalesReps);
		// 			}
		// 		},
		// 		errorResponse => {
		// 			console.log("errorResponse", errorResponse);
		// 			apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
		// 		}
		// 	);
		// },
		getDiscountGroups(){
			this.loading = true;
			let request ={
				pageNumber: 1,
				pageSize: 500,
				isActive: true,
			};
			orderService.getDiscountGroups(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.discountGroups = successResponse.data.result;
						this.discountGroups = dataTableHelper.castFieldValues(this.discountGroups);
						this.discountGroups = $.map(this.discountGroups,
							function (obj) {
								obj.id = obj.id || obj.discountGroupId;
								obj.text = obj.text || obj.name;
								return obj;
							});
					}
					this.loading = false;
				},
				errorResponse => {
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getProductTypes(){
			productService.getProductTypes().then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.productTypes = successResponse.data.result;
						for(let i = 0 ; i < this.productTypes.length; i++){
							this.productTypes[i].selected = false;
						}
						if(this.companyId !== null && this.companyId > 0){
							this.getCompanyProductTypes();
						}
					}
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getCompanyProductTypes(){
			productService.getCompanyProductTypes(this.companyId).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.customerProductTypes = successResponse.data.result;
						for(let i = 0 ; i < this.productTypes.length; i++){
							for(let j = 0; j < this.customerProductTypes.length; j++){
								if(this.productTypes[i].productTypeId === this.customerProductTypes[j].productTypeId){
									this.productTypes[i].selected = true;
									break;
								}
							}
						}
					}
					console.log("productTypes", this.productTypes);
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		generateCustomerCode(){
			securityService.generateCustomerCode().then(
				successResponse => {
					console.log("successResponse", successResponse);
					var isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						this.customer.customerCode.value = successResponse.data.customerCode;
					}
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
        calculateAmountOfCreditUsed(){
            let creditLimit = this.customer.creditLimit.value === null || this.customer.creditLimit.value === undefined ? 0 : this.customer.creditLimit.value;
            this.amountOfCreditUsed = creditLimit - this.currentBalance;
        },
		successModelOkClicked(){
			this.successModal = {
				modalHeading: "Success",
				elementId: "customerModalSuccess",
				modalMessage: "",
				showModal: false
			};
			if(this.isUpdate){
				this.$router.go(-1);
			}
		},
		errorModelOkClicked(){
			this.errorModal = {
				modalHeading: "Error",
				elementId: "customerModalError",
				modalMessage: "",
				showModal: false
			};
		},
		onProductTypeSelect(productType){
			console.log("productType", productType);
			if(productType.selected){
				this.customer.productTypeIdsToLink.value.push(productType.productTypeId);
				this.customer.productTypeIdsToUnlink.value = this.customer.productTypeIdsToUnlink.value.filter(function (value) {
					return value !== productType.productTypeId;
				});
			}
			else{
				this.customer.productTypeIdsToUnlink.value.push(productType.productTypeId);
				this.customer.productTypeIdsToLink.value = this.customer.productTypeIdsToLink.value.filter(function (value) {
					return value !== productType.productTypeId;
				});
			}
		},
		onPasswordGenerated(password){
			this.customer.password.value = password;
		},
		onDiscountGroupSelect(discountGroup){
			console.log("discountGroup", discountGroup);
			this.customer.companyDetails.discountGroupId.value = discountGroup.id;
		},
		// onSalesRepSelect(salesRep){
		// 	this.customer.companyDetails.salesRepId = salesRep.id;
		// },
		unAssignSalesRep(userId){
			this.companySalesReps = this.companySalesReps.filter(salesRep => salesRep.userId !== userId);
			this.unselectedSalesReps.push(this.saleReps.filter(salesRep => salesRep.userId === userId)[0]);
			this.updateSalesRepsList();
		},
		selectSalesRepForCustomer(){
			this.customerSalesRep.showModal = true;
		},
		onAssignSalesRepToCustomerCloseClick(){
			this.customerSalesRep.showModal = false;
		},
		onSalesRepsSelectedForCustomer(selectedAndUnselectedSalesReps){
			console.log("selectedAndUnselectedSalesReps", selectedAndUnselectedSalesReps);
			// this.customer.companyDetails.salesRepId.value = selectedSalesRep.userId;
			// this.customer.companyDetails.salesRepName.value = selectedSalesRep.firstName + " " + selectedSalesRep.lastName;
			this.companySalesReps = selectedAndUnselectedSalesReps.selectedSalesReps;
			this.unselectedSalesReps = selectedAndUnselectedSalesReps.unselectedSalesReps;
			this.updateSalesRepsList();
			this.customerSalesRep.showModal = false;
		},
		onZoneSelect(){
			this.linkedZoneIds = this.companyZonesLinkedAndUnlinkedToCompany.filter(zone => zone.isSelected).map(zone => zone.zoneId);
			this.unlinkedZoneIds = this.companyZonesLinkedAndUnlinkedToCompany.filter(zone => !zone.isSelected).map(zone => zone.zoneId);
		},
        onPaymentTypeSelect(paymentType){
            this.customer.paymentTypeId.value = paymentType.id;
			console.log("customer.paymentTypeId.value", this.customer.paymentTypeId.value);
            // if(this.customer.paymentTypeId.value === this.paymentType.COD){
            //     this.customer.creditLimit.value = 0;
            // }
        },
		updateSalesRepsList(){
			for(var i = 0; i < this.saleReps.length; i++){
				let item = this.companySalesReps.find(salesRepItem => salesRepItem.userId === this.saleReps[i].userId);
				if(item !== null && item !== undefined){
					this.saleReps[i].isAssigned = true;
				}
				else{
					if(this.unselectedSalesReps.some(salesRepItem => salesRepItem.userId === this.saleReps[i].userId)) {
						this.saleReps[i].isAssigned = false;
					}
				}
			}
		},
		onDateOfBirthSelect(dateOfBirth){
			this.customer.dateOfBirth.value = dateOfBirth;
			this.initialiseDueDate = false;
		},
		onBackClick(){
			this.$router.go(-1);
		},
		validateSaveCustomer(){
			this.regeneratePassword = false;
			this.saveCustomer();
		},
		saveCustomer(){
			this.loading = true;
			
			if(this.customer.customerCanPlaceExTankOrders){
				if(this.linkedZoneIds === null || this.linkedZoneIds === undefined || this.linkedZoneIds.length === 0){
					this.loading = false;
					this.linkZonesErrorMessage = "Please select at least one zone";
					return;
				}
			}
			
			let companyId = this.companyId;
			if(this.companyId === null || this.companyId === undefined || this.companyId === ""){
				companyId = 0;
			}

			let savePassword = true;
			if(this.isUpdate && !this.resetPassword){
				savePassword = false;
			}
			//
			var newProductTypeIdsToLink = [];
			var productTypeIdsToUnlink = [];
			var self = this;
			for(var i = 0; i < this.productTypes.length; i++){
				if(this.productTypes[i].selected){
					newProductTypeIdsToLink.push(this.productTypes[i].productTypeId);
					productTypeIdsToUnlink = productTypeIdsToUnlink.filter(function (value) {
						return value !== self.productTypes[i].productTypeId;
					});
				}
				else{
					productTypeIdsToUnlink.push(this.productTypes[i].productTypeId);
					newProductTypeIdsToLink = newProductTypeIdsToLink.filter(function (value) {
						return value !== self.productTypes[i].productTypeId;
					});
				}
			}
			
			var linkedSalesRepIds= [];
			for(let i = 0; i < this.companySalesReps.length; i++){
				linkedSalesRepIds.push(this.companySalesReps[i].userId);
			}
			
			var unlinkedSalesRepIds = [];
			for(let i = 0; i < this.unselectedSalesReps.length; i++){
				unlinkedSalesRepIds.push(this.unselectedSalesReps[i].userId);
			}
			
			// for(var j = 0; j < this.customer.productTypeIdsToUnlink.value.length; j++){
			// 	if(this.customerProductTypes.filter(function (value) {
			// 		return value.productTypeId === self.customer.productTypeIdsToUnlink.value[j];
			// 	}).length > 0){
			// 		productTypeIdsToUnlink.push(this.customer.productTypeIdsToUnlink.value[j]);
			// 	}
			// }
			this.linkZonesErrorMessage = null;
			let request = {
				companyId: companyId,
				primaryUserId: this.customer.primaryUserId,
				customerCode: this.customer.customerCode.value,
				firstName: this.customer.firstName.value,
				lastName: this.customer.lastName.value,
				emailAddress: this.customer.emailAddress.value,
				password: this.customer.password.value,
				dateOfBirth: this.customer.dateOfBirth.value,
				enableCollectionOrders: this.customer.customerCanPlaceCollectionOrders,
				enableDeliveryOrders: this.customer.customerCanPlaceDeliveryOrders,
				enableExTankOrders: this.customer.customerCanPlaceExTankOrders,
				registeredCompanyName: this.customer.companyDetails.businessName.value,
				tradingName: this.customer.companyDetails.tradingName.value,
				holdingCompany: this.customer.companyDetails.holdingCompany.value,
				companyRegistrationNumber: this.customer.companyDetails.registrationNumber.value,
				branchName: this.customer.companyDetails.branch.value,
				branchNumber: this.customer.companyDetails.branchNumber.value,
				primaryTelephoneNumber: this.customer.companyDetails.telephoneNumber.value,
				discountGroupId: this.customer.companyDetails.discountGroupId.value,
				erpCustomerCode: this.customer.companyDetails.erpCustomerCode.value,
				salesRepId: this.customer.companyDetails.salesRepId.value,
				taxVatNumber: this.customer.companyDetails.vatNumber.value,
				isActive: this.customer.isActive,
				savePassword: savePassword,
				productTypeIdsToLink: newProductTypeIdsToLink,
				productTypeIdsToUnlink: productTypeIdsToUnlink,
				salesRepToLinkUserIds: linkedSalesRepIds,
				salesRepToUnlinkUserIds: unlinkedSalesRepIds,
				zoneIdsToLink: this.linkedZoneIds,
				zoneIdsToUnlink: this.unlinkedZoneIds,
                paymentTypeId: this.customer.paymentTypeId.value,
                creditLimit: this.customer.creditLimit.value
			};
			customerService.addOrUpdateCompany(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						if(!successResponse.data.customerValidationResponse.valuesAreValid){
							this.customer.customerCode.hasError = successResponse.data.customerValidationResponse.customerCodeValidationResponse.hasError;
							this.customer.customerCode.errorMessage = successResponse.data.customerValidationResponse.customerCodeValidationResponse.message;
							
							this.customer.firstName.hasError = successResponse.data.customerValidationResponse.firstNameValidationResponse.hasError;
							this.customer.firstName.errorMessage = successResponse.data.customerValidationResponse.firstNameValidationResponse.message;
							
							this.customer.lastName.hasError = successResponse.data.customerValidationResponse.lastNameValidationResponse.hasError;
							this.customer.lastName.errorMessage = successResponse.data.customerValidationResponse.lastNameValidationResponse.message;
							
							this.customer.emailAddress.hasError = successResponse.data.customerValidationResponse.emailValidationResponse.hasError;
							this.customer.emailAddress.errorMessage = successResponse.data.customerValidationResponse.emailValidationResponse.message;
							
							this.customer.password.hasError = successResponse.data.customerValidationResponse.passwordValidationResponse.hasError;
							this.customer.password.errorMessage = successResponse.data.customerValidationResponse.passwordValidationResponse.message;
							
							this.customer.dateOfBirth.hasError = successResponse.data.customerValidationResponse.dateOfBirthValidationResponse.hasError;
							this.customer.dateOfBirth.errorMessage = successResponse.data.customerValidationResponse.dateOfBirthValidationResponse.message;
							
							if(successResponse.data.customerValidationResponse.enableCollectionOrdersOrDeliveryOrdersValidationResponse.hasError){
								this.customer.customerCanPlaceOrdersErrorMessage = successResponse.data.customerValidationResponse.enableCollectionOrdersOrDeliveryOrdersValidationResponse.message;
							}
							
							this.customer.companyDetails.businessName.hasError = successResponse.data.customerValidationResponse.registeredBusinessNameValidationResponse.hasError;
							this.customer.companyDetails.businessName.errorMessage = successResponse.data.customerValidationResponse.registeredBusinessNameValidationResponse.message;
							
							this.customer.companyDetails.tradingName.hasError = successResponse.data.customerValidationResponse.businessTradingNameValidationResponse.hasError;
							this.customer.companyDetails.tradingName.errorMessage = successResponse.data.customerValidationResponse.businessTradingNameValidationResponse.message;
							
							this.customer.companyDetails.registrationNumber.hasError = successResponse.data.customerValidationResponse.businessRegistrationNumberValidationResponse.hasError;
							this.customer.companyDetails.registrationNumber.errorMessage = successResponse.data.customerValidationResponse.businessRegistrationNumberValidationResponse.message;
							
							// this.customer.companyDetails.vatNumber.hasError = successResponse.data.customerValidationResponse.vatNumberValidationResponse.hasError;
							// this.customer.companyDetails.vatNumber.errorMessage = successResponse.data.customerValidationResponse.vatNumberValidationResponse.message;
							
							// this.customer.companyDetails.salesRepId.hasError = successResponse.data.customerValidationResponse.salesRepValidationResponse.hasError;
							// this.customer.companyDetails.salesRepId.errorMessage = successResponse.data.customerValidationResponse.salesRepValidationResponse.message;
							
							this.customer.companyDetails.telephoneNumber.hasError = successResponse.data.customerValidationResponse.phoneNumberValidationResponse.hasError;
							this.customer.companyDetails.telephoneNumber.errorMessage = successResponse.data.customerValidationResponse.phoneNumberValidationResponse.message;

							this.customer.companyDetails.discountGroupId.hasError = successResponse.data.customerValidationResponse.discountGroupValidationResponse.hasError;
							this.customer.companyDetails.discountGroupId.errorMessage = successResponse.data.customerValidationResponse.discountGroupValidationResponse.message;

							this.customer.productTypeIdsToLink.hasError = successResponse.data.customerValidationResponse.productTypeIdsToLinkResponse.hasError;
							this.customer.productTypeIdsToLink.errorMessage = successResponse.data.customerValidationResponse.productTypeIdsToLinkResponse.message;
							
							this.customer.salesRepsToLinkMessage.hasError = successResponse.data.customerValidationResponse.salesRepUserIdsToLinkValidationResponse.hasError;
							this.customer.salesRepsToLinkMessage.errorMessage = successResponse.data.customerValidationResponse.salesRepUserIdsToLinkValidationResponse.message;
                            
                            this.customer.creditLimit.hasError = successResponse.data.customerValidationResponse.creditLimitValidationResponse.hasError;
                            this.customer.creditLimit.errorMessage = successResponse.data.customerValidationResponse.creditLimitValidationResponse.message;

                            this.customer.paymentTypeId.hasError = successResponse.data.customerValidationResponse.paymentTypeValidationResponse.hasError;
                            this.customer.paymentTypeId.errorMessage = successResponse.data.customerValidationResponse.paymentTypeValidationResponse.message;
						}
						else{
							this.successModal.showModal = true;
							this.successModal.modalHeading = "Success";
							this.successModal.modalMessage = "Customer saved successfully";
							this.clearCustomerModel();
							this.generateCustomerCode();
						}
					}
					else{
						if(successResponse.data.responseCodes !== null){
							for(var i = 0; i < successResponse.data.responseCodes.length; i++){
								if(successResponse.data.responseCodes[i] === responseStatus.responseCode.emailAlreadyExists){
									this.onBackClick();
								}
							}
						}
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
					this.loading = false;
				}
			);
		},
		clearCustomerModel(){
			this.customer = {
				customerCode: {
					value: null,
						hasError: false,
						errorMessage: null
				},
				firstName: {
					value: null,
						hasError: false,
						errorMessage: null
				},
				lastName: {
					value: null,
						hasError: false,
						errorMessage: null
				},
				emailAddress: {
					value: null,
						hasError: false,
						errorMessage: null
				},
				password: {
					value: null,
						hasError: false,
						errorMessage: null
				},
				dateOfBirth: {
					value: null,
						hasError: false,
						errorMessage: null
				},
                paymentTypeId:{
                    value: null,
                    hasError: false,
                    errorMessage: null
                },
                creditLimit: {
                    value: null,
                    hasError: false,
                    errorMessage: null
                },
				customerCanPlaceOrdersErrorMessage: null,
					customerCanPlaceCollectionOrders: false,
					customerCanPlaceDeliveryOrders: false,
					companyDetails: {
					businessName: {
						value: null,
							hasError: false,
							errorMessage: null
					},
					tradingName: {
						value: null,
							hasError: false,
							errorMessage: null
					},
					holdingCompany: {
						value: null,
							hasError: false,
							errorMessage: null
					},
					registrationNumber: {
						value: null,
							hasError: false,
							errorMessage: null
					},
					branch: {
						value: null,
							hasError: false,
							errorMessage: null
					},
					branchNumber: {
						value: null,
							hasError: false,
							errorMessage: null
					},
					telephoneNumber: {
						value: null,
							hasError: false,
							errorMessage: null
					},
					discountGroupId: {
						value: null,
							hasError: false,
							errorMessage: null
					},
					erpCustomerCode: {
						value: null,
							hasError: false,
							errorMessage: null
					},
					salesRepId: {
						value: null,
							hasError: false,
							errorMessage: null
					},
					salesRepName: {
						value: null,
							hasError: false,
							errorMessage: null
					},
					vatNumber: {
						value: null,
							hasError: false,
							errorMessage: null
					}
				},
				isActive: true,
				productTypeIdsToLink: {
					value: [],
					hasError: false,
					errorMessage: null
				},
				productTypeIdsToUnlink: {
					value: [],
					hasError: false,
					errorMessage: null
				},
				salesRepsToLinkMessage:{
					value: null,
					hasError: false,
					errorMessage: null
				}
			};
			this.companySalesReps = [];
			this.getZonesLinkedAndUnlinkedToCompany();
			this.getSalesRepsAssignedToCompany();
			this.generateCustomerCode();
			this.getProductTypes();
			this.regeneratePassword = true;
		},
		setBreadcrumbs() {
			var pageTitle = "Add Customer";
			if(this.companyId != null && this.companyId > 0){
				pageTitle = this.customer.companyDetails.businessName.value === null ? "Edit Customer" : "Edit Customer - " + this.customer.companyDetails.businessName.value;
			}
			storeState.setPageTitleAction(pageTitle);
			breadcrumbsStoreState.updateBreadcrumbs(this.$route, pageTitle);
		}
	},
	mounted: function () {
        this.getPaymentTypes();
		this.getProductTypes();
		this.getDiscountGroups();
		permissionsHelper.setControlsBasedOnPermissions();
	},
	watch: {
		companyId: {
			handler: function () {
				// if (this.companyId !== null && this.companyId > 0) {
				// 	this.isUpdate = true;
				// 	this.getCustomer();
				// 	//this.getCompanySalesReps();
				// }
				// else{
				// 	this.setBreadcrumbs();
				// 	this.isUpdate = false;
				// 	this.generateCustomerCode();
				// }
				// this.getSalesRepsAssignedToCompany();
				// this.getZonesLinkedAndUnlinkedToCompany();
				this.setBreadcrumbs();
			},
			immediate: true,
			deep: true
		},
        'customer.creditLimit.value': {
            handler: function () {
                if(this.companyId !== null && this.companyId > 0) {
                    this.calculateAmountOfCreditUsed();
                }
            },
            immediate: true,
            deep: true
        }
	}
};